import { render, staticRenderFns } from "./ClassicalList.vue?vue&type=template&id=0bdcc564&scoped=true"
import script from "./ClassicalList.vue?vue&type=script&lang=js"
export * from "./ClassicalList.vue?vue&type=script&lang=js"
import style0 from "./ClassicalList.vue?vue&type=style&index=0&id=0bdcc564&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdcc564",
  null
  
)

export default component.exports